<template>
    <section class="section--comp success-stories-bg">
        <div class="container items-center">
            <h3 class="section--h3 text-white">Success Stories</h3>
            <swiper class="swiper" :options="swiperOption">
                <swiper-slide>
                    <div class="p-5 text-white">
                        <!-- <img class="img-fluid img-rounded w-1/12 mb-base" src="../../../../src/assets/images/demo/int-success-stories1.png" /> -->
                        <p class="section--p text-white">
                            "Applying agile methodology to microlearning to deliver
training that is customized to each learner using adaptive algorithms. It is a concept of competently
designing, delivering, and evolving learning content with an emphasis on results."
                        </p>
                        <div class="mb-base">
                            <span>Multinational Logistics Company</span><!--<span class="font-bold text-uppercase">HR Director</span>-->
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="p-5 text-white">
                        <!-- <img class="img-fluid img-rounded w-1/12 mb-base" src="../../../../src/assets/images/demo/int-success-stories1.png" /> -->
                        <p class="section--p text-white">
                            "The increased flexibility of training and onboarding our interns translates into a more effective, engaging
and enjoyable user experience, since it reduces the cognitive load on today's busy and time-sensitive
next-gen learners."
                        </p>
                        <div class="mb-base">
                            <span>Event Onboarding ALTF</span><!--<span class="font-bold text-uppercase">New York Business Center</span>-->
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="p-5 text-white">
                        <!-- <img class="img-fluid img-rounded w-1/12 mb-base" src="../../../../src/assets/images/demo/int-success-stories1.png" /> -->
                        <p class="section--p text-white">
                            "Career based personality analysis has allowed us to strategically add a new dimension to our fitment
processes. We now utilize behavioural skill data just as technical skills for a role in our company."
                        </p>
                        <div class="mb-base">
                            <span>Multinational Telecom Client</span><!--<span class="font-bold text-uppercase">New York Business Center</span>-->
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev" style="color: white;"></div>
                <div class="swiper-button-next" slot="button-next" style="color: white;"></div>
            </swiper>
        </div>    
    </section>
</template>

<script>
// import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
    name: 'SuccessStories',
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOption: {
            spaceBetween: 30,
            centeredSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        }
      }
    }
}
</script>

<style scoped>
.success-stories-bg {
    background: linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%);
}
</style>